// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Margins} from './margins.js'
import {Paper} from './paper.js'
import {PDFAsset} from './pdfasset.js'
import {Size} from './size.js'

export class PageBackground {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PageBackground {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPageBackground(bb: flatbuffers.ByteBuffer, obj?: PageBackground): PageBackground {
    return (obj || new PageBackground()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPageBackground(bb: flatbuffers.ByteBuffer, obj?: PageBackground): PageBackground {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PageBackground()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  paper(obj?: Paper): Paper | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Paper()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  pdf(obj?: PDFAsset): PDFAsset | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new PDFAsset()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  rotation(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0
  }

  size(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  margins(obj?: Margins): Margins | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new Margins()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startPageBackground(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addPaper(builder: flatbuffers.Builder, paperOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, paperOffset, 0)
  }

  static addPdf(builder: flatbuffers.Builder, pdfOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, pdfOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotation: number) {
    builder.addFieldFloat32(2, rotation, 0.0)
  }

  static addSize(builder: flatbuffers.Builder, sizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, sizeOffset, 0)
  }

  static addMargins(builder: flatbuffers.Builder, marginsOffset: flatbuffers.Offset) {
    builder.addFieldStruct(4, marginsOffset, 0)
  }

  static endPageBackground(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
